var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDevlens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD8BD",
    d: "M0 10C0 4.477 4.477 0 10 0h40c5.523 0 10 4.477 10 10v40c0 5.523-4.477 10-10 10H10C4.477 60 0 55.523 0 50V10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    fillRule: "evenodd",
    d: "M23.675 15.75c-2.39 0-4.39.851-5.789 2.352-1.393 1.494-2.135 3.573-2.135 5.937v1.074h28.498V24.04c0-2.363-.737-4.442-2.129-5.937-1.397-1.501-3.397-2.352-5.794-2.352h-12.65Zm-2.24 4.951a1.125 1.125 0 0 0 0 2.25h.082a1.125 1.125 0 0 0 0-2.25h-.083Zm3.728 0a1.125 1.125 0 0 0 0 2.25h.083a1.125 1.125 0 0 0 0-2.25h-.083Zm3.73 0a1.125 1.125 0 0 0 0 2.25h.082a1.125 1.125 0 0 0 0-2.25h-.083Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    d: "M29.49 32.25a2.821 2.821 0 1 0 0 5.642 2.821 2.821 0 0 0 0-5.642Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    fillRule: "evenodd",
    d: "M15.75 35.96v-8.597h28.5v8.596c0 2.364-.738 4.443-2.13 5.938-1.398 1.5-3.398 2.352-5.795 2.352h-12.65c-2.396 0-4.397-.852-5.794-2.352-1.392-1.495-2.13-3.574-2.13-5.938Zm8.669-.889a5.071 5.071 0 1 1 9.324 2.763l1.509 1.509a1.125 1.125 0 1 1-1.591 1.59l-1.532-1.531a5.071 5.071 0 0 1-7.71-4.33Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDevlens);
export default __webpack_public_path__ + "static/media/logo-devlens.fabff81c65f6c2de5590bc9d7d8e667a.svg";
export { ForwardRef as ReactComponent };